
import Vue from "vue";
import {CustomViewTab} from "@/utils/tabs/custom-view-tab";
import {AuthService, BookYearService} from "@/services";
import { processIframeUrl } from "@/utils/iframe";

export default Vue.extend({
	data(){
		return {
			url: "",
			childOrigin: ""
		};
	},
	props: {
		tabs: {
			type: Array as ()=>CustomViewTab[],
		},
		tab: Number,
		startTabIndex: Number,
		model: {
			type: Object,
			required: false,
		},
	},
	computed: {
		currentTab():number{
			return (this.startTabIndex - this.tab)*-1;
		},
		computedUrl():string{
			let tab = this.currentTab >= 0 ? this.tabs[this.currentTab] : null;
			let url = processIframeUrl(this.url, {
				useElectronServerAsProxy: tab?.UseDesktopAppAsProxy || false
			});
			if(this.model){
				url = url.replace("{id}",this.model.ID.toString());
			}
			return url;
		}
	},
	watch: {
		tab(){
			if(this.currentTab>=0){
				this.url = this.tabs[this.currentTab].Url;
			}
		}
	},
	methods: {
		sendAppData(frame: HTMLIFrameElement) {
			if (!this.childOrigin) return;
			let app = {
				bookyear: BookYearService.selectedBookYear,
				dossier: AuthService.wfDossier.id,
				userId: AuthService.wfUser.ID,
				accessToken: AuthService.tokenStore.getSelectedToken().token,
				socketId: AuthService.tokenStore.socketId
			};
			frame.contentWindow?.postMessage({data: this.model, app}, this.childOrigin);
		},
		async onMessage(e: MessageEvent){
			if (e.data?.type === "IFRAME_READY") {
				this.childOrigin = e.origin;
				let frame = this.$refs.frame as HTMLIFrameElement;
				if(frame){
					setTimeout(()=>{
						this.sendAppData(frame);
					},150);
				}
			}

			if (e.data?.type === "REQUEST_TOKEN") {
				// Refresh tokens if needed, then send fresh token to iframe
				await AuthService.refreshTokensIfRequired();
				let frame = this.$refs.frame as HTMLIFrameElement;
				if(frame){
					this.sendAppData(frame);
				}
			}

			if (e.data?.type === "IFRAME_UPDATE") {
				this.$emit("update-parent",e.data?.data);
			}
		},
	},
	mounted(){
		this.url = this.tabs[this.currentTab].Url;
		window.addEventListener("message", (e) => {
			this.onMessage(e);
		});
	},
	beforeDestroy() {
		window.removeEventListener("message",this.onMessage);
	}
});
